import { useMutation, useQueryClient } from "@tanstack/react-query";
import { approveUserRequest } from "../services/approve-user-request";

export function useApproveUserRequest() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => approveUserRequest(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["user-requests"] });
    },
  });
}
